<template>
    <label class="switch">
        <input type="checkbox" checked>
        <div class="slider round">
            <span>RU</span>
            <span>UA</span>
        </div>
    </label>
</template>

<script>
    export default {
        name: "SlideButton",
        props: {
            style_class: {
                type: String,
                default: ''
            }
        }
    };
</script>

<style scoped lang="scss">
    .switch {
        position: relative;
        display: inline-block;
        width: 88px;
        height: 28px;
        input {
            opacity: 0;
            width: 0;
            height: 0;
            &:checked + .slider {
                background-color: #fff;
            }
            &:checked + .slider:before {
                transform: translateX(44px);
            }
        }
        .slider {
            display: flex;
            align-items: center;
            position: absolute;
            cursor: pointer;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background-color: #fff;
            transition: .4s;
            > span {
                color: #3F4450;
                font-size: 12px;
                position: absolute;
                &:first-child {
                    left: 12px;
                }
                &:last-child {
                    right: 12px;
                }
            }
            &:before {
                position: absolute;
                content: "";
                height: 100%;
                width: 44px;
                left: 0;
                bottom: 0;
                background-color: #E1E6EA;
                transition: .4s;
            }
        }
    }
    /* Rounded sliders */
    .slider.round {
        border-radius: 53px;
    }

    .slider.round:before {
        border-radius: 53px;
    }
</style>
